export default "__VITE_ASSET__CyhGqmYk__"